  import {
  USUARIOS_GET_CAR_LOTS_BEGIN,
  USUARIOS_GET_CAR_LOTS_SUCCESS,
  USUARIOS_GET_CAR_LOTS_FAILURE,
  USUARIOS_GET_CAR_LOTS_DISMISS_ERROR,
} from './constants';
import axios from "axios";
import { REACT_APP_API_ABM_FW } from '../../../common/config';
// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function getCarLots(args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: USUARIOS_GET_CAR_LOTS_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      const doRequest = axios.get(REACT_APP_API_ABM_FW + "/abms/car_lot" + args);
      doRequest.then(
        (res) => {
          if (res.data.success) {
            let data = res.data.data.map((car_lot) => {
              return { value: car_lot.id, label: car_lot.name, checked: false }
            });
            dispatch({
              type: USUARIOS_GET_CAR_LOTS_SUCCESS,
              data: data,
            });
            resolve(data);
          } else {
            dispatch({
              type: USUARIOS_GET_CAR_LOTS_FAILURE,
              data: [],
            });
            reject([]);
          }
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: USUARIOS_GET_CAR_LOTS_FAILURE,
            data: [],
          });
          reject([]);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetCarLotsError() {
  return {
    type: USUARIOS_GET_CAR_LOTS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case USUARIOS_GET_CAR_LOTS_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getCarLotsPending: true,
        getCarLotsError: null,
      };

    case USUARIOS_GET_CAR_LOTS_SUCCESS:
      // The request is success
      return {
        ...state,
        getCarLotsPending: false,
        getCarLotsError: null,
        car_lots: [...action.data]
      };

    case USUARIOS_GET_CAR_LOTS_FAILURE:
      // The request is failed
      return {
        ...state,
        getCarLotsPending: false,
        getCarLotsError: action.data.error,
        car_lots: [...action.data]
      };

    case USUARIOS_GET_CAR_LOTS_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getCarLotsError: null,
      };

    default:
      return state;
  }
}
